module.exports = __webpack_public_path__ + "img/title.2fb3a343.png";